import {
  Box,
  Button,
  Card,
  CardActions,
  CircularProgress,
} from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { Form, required, TextInput, useNotify } from "react-admin";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { saveTokenRefreshMeta } from "../authProvider";
import sendRequest from "../dataProvider/sendRequest";

interface FormValues {
  verifycode: string;
}

const VerifyBankerLogin = () => {
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const navigate = useNavigate();

  const [successMessage, setSuccessMessage] = React.useState("");
  const handleSubmit = async (auth: FieldValues) => {
    setLoading(true);
    const reqUrl = "verify-banker-login";
    const formJson = {
      verifycode: String(auth.verifycode ?? ""),
    };
    const response = await sendRequest(reqUrl, {
      id: 0,
      data: formJson,
    });
    if (response && (response.status == "200" || response.code == "200")) {
      const bankerData = response.data;
      const bankerUser = bankerData?.user ?? bankerData;
      const accessToken = bankerData?.access_token ?? response.access_token;
      const refreshToken = bankerData?.refresh_token ?? response.refresh_token;

      if (!bankerData || !bankerUser || !accessToken) {
        setSuccessMessage("Verification failed");
        notify("Verification succeeded but login token is missing", {
          type: "error",
        });
        setLoading(false);
        return;
      }

      setSuccessMessage("Verification successful");
      // localStorage.setItem("username", banker.name);
      // // localStorage.setItem("email", banker.email);
      // // localStorage.setItem("auth", JSON.stringify(banker));
      // localStorage.setItem("division", "Personal");
      // localStorage.setItem(
      //   "authrole",
      //   banker.admin ? "admin" : banker.bankadmin ? "bankadmin" : ""
      // );
      // if (banker.admin) {
      //   localStorage.setItem("bank", "");
      //   localStorage.setItem("bankId", "");
      // } else {
      //   localStorage.setItem("bank", banker.bank);
      //   localStorage.setItem("bankId", banker.id);
      // }
      // localStorage.setItem("all_experts", "");

      if (bankerData) {
        localStorage.setItem(
          "bbaccess",
          bankerData.bbaccess ?? bankerUser.bbaccess ?? ""
        );
        localStorage.setItem(
          "username",
          bankerData.name ?? bankerUser.name ?? ""
        );
        localStorage.setItem(
          "email",
          bankerData.email ?? bankerUser.email ?? ""
        );
        localStorage.setItem("access_token", accessToken);
        if (refreshToken) {
          localStorage.setItem("refresh_token", refreshToken);
        }
        saveTokenRefreshMeta(response.expires_in ?? bankerData.expires_in);
        localStorage.setItem("division", "Personal");
        localStorage.setItem(
          "authrole",
          bankerUser.admin ? "admin" : bankerUser.bankadmin ? "bankadmin" : ""
        );
        if (bankerUser.admin) {
          localStorage.setItem("bank", "");
          localStorage.setItem("bankId", "");
        } else {
          localStorage.setItem(
            "bank",
            bankerData.bank ?? bankerUser.bank ?? ""
          );
          localStorage.setItem(
            "bankId",
            String(bankerData.bankId ?? bankerUser.bankId ?? "")
          );
        }

        localStorage.setItem("all_experts", "");

        navigate("/", { replace: true });
        return;
      }

      setLoading(false);
      setTimeout(() => {
        navigate("/");
        // navigate("/login");
      }, 2000);
    } else {
      if (response && response.message) {
        setSuccessMessage("Verification failed");
      } else {
        notify("Email send failed", { type: "error" });
      }

      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "flex-start",
          backgroundColor: "#f2f7fa",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Card sx={{ minWidth: 300, marginTop: "6em", padding: "2em" }}>
          <Box
            sx={{
              margin: "1em",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img src="/images/happymango_logo.png" alt="logo" />
          </Box>
          <Box
            sx={{
              marginTop: "1em",
              display: "flex",
              justifyContent: "center",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            Account Security Check
          </Box>
          <Box
            sx={{
              marginTop: "1em",
              display: "flex",
              justifyContent: "center",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            A verification code has been sent to your email address. <br />
            Please enter the code to access the system.
          </Box>
          {successMessage && (
            <>
              <Box
                sx={{
                  marginTop: "1em",
                  display: "flex",
                  justifyContent: "center",
                  color: (theme) => theme.palette.success.main,
                }}
              >
                {successMessage}
              </Box>
              <Box
                sx={{
                  textAlign: "center",
                  width: "100%",
                  mt: 1,
                }}
              >
                {/* <Link
                  to="/login"
                  style={{
                    textDecoration: "none",
                    color: "#00CCB1",
                  }}
                >
                  Back to Login
                </Link> */}
              </Box>
            </>
          )}
          {!successMessage && (
            <>
              <Box sx={{ mt: 2, padding: "0 1em 1em 1em" }}>
                <TextInput
                  source="verifycode"
                  label="Verification Code"
                  type="text"
                  variant="outlined"
                  fullWidth
                  validate={required()}
                />
              </Box>
              <CardActions
                sx={{
                  padding: "0 1em 1em 1em",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disabled={loading}
                  sx={{
                    backgroundColor: "#00ccb1",
                    "&:hover": {
                      backgroundColor: "#00b39b",
                    },
                  }}
                >
                  {loading && <CircularProgress size={25} thickness={2} />}
                  Verify
                </Button>
              </CardActions>
            </>
          )}
        </Card>
      </Box>
    </Form>
  );
};

export default VerifyBankerLogin;
